export const getPhoneFromMessage = (phone_number) => {
    return {
        type: 'PHONE_NUMBER',
        payload: phone_number
    }
}